function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserServiceRelativityImpersonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    fill: "none",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.897 89.397c-18.199 0-32.948-14.75-32.948-32.949 0-18.198 14.75-32.948 32.948-32.948 18.199 0 32.949 14.75 32.949 32.948 0 18.2-14.75 32.949-32.949 32.949",
    fill: "#ffa726",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.076 102.576c-1.487 0-2.946.04-4.377.115v.055c-43.764 2.779-60.494 40.065-60.494 40.065L30 168.473h130.973l-.205-25.662s-16.732-37.286-60.495-40.065v-.055a82.579 82.579 0 0 0-4.377-.115c-.138 0-.272.005-.41.006-.137 0-.272-.006-.41-.006z",
    fill: "#b5c7cd",
    strokeMiterlimit: 10,
    strokeWidth: 1.6474,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 126.18,
    width: 56.099,
    height: 56.099,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 9.2015,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 102.63,
    width: 56.099,
    height: 56.099,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 9.2015,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0304 0 0 2.0304 -143.58 -172.82)",
    fill: "none",
    stroke: "#f8981d",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.52,
    y: 138.29,
    width: 24.387,
    height: 24.387,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.52,
    y: 150.29,
    width: 24.387,
    height: 24.387,
    style: {
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserServiceRelativityImpersonation);
export default __webpack_public_path__ + "static/media/userServiceRelativityImpersonation.ed53ff68a56a7410fff99eabb3056d05.svg";
export { ForwardRef as ReactComponent };